// extracted by mini-css-extract-plugin
export default {"route":"Item_route__pZiR+","routeContent":"Item_routeContent__fepWl"};